export default {
  orsDictionary: {
    unknown: 'Neznámý',
    paved: 'Zpevněný',
    unpaved: 'Nezpevněný',
    asphalt: 'Asfalt',
    concrete: 'Beton',
    cobblestone: 'Dlažba',
    metal: 'Kovový',
    wood: 'Dřevěný',
    compactedGravel: 'Zhutněný štěrk',
    fineGravel: 'Jemný štěrk',
    gravel: 'Štěrk',
    dirt: 'Prach',
    ground: 'Hlína',
    ice: 'Led',
    pavingStones: 'Dlažební kostky',
    sand: 'Písek',
    woodchips: 'Dřevní štěpka',
    grass: 'Tráva',
    grassPaver: 'Travnatý povrch',
    none: 'Žádný',
    no: 'Ne',
    customers: 'Zákazníci',
    destination: 'Cíl',
    delivery: 'Zásobovací',
    private: 'Soukromá',
    permissive: 'Povolen',
    permit: 'Na povolení',
    stateRoad: 'Státní silnice',
    road: 'Silnice',
    street: 'Ulice',
    path: 'Cesta',
    track: 'Trasa',
    cycleway: 'Cyklostezka',
    footway: 'Chodník',
    steps: 'Schody',
    ferry: 'Trajekt',
    construction: 'Ve výstavbě',
    'concrete:lanes': 'Betonové pásy',
    paving_stones: 'dlažební kostky',
    sett: 'mozaiková dlažba',
    unhewn_cobblestone: 'Hrubá dlažba',
    compacted: 'Zhutněný',
    fine_gravel: 'Jemný štěrk',
    pebblestone: 'Oblázková dlažba',
    impassable: 'Neprůjezdné',
    very_horrible: 'Velmi strašné',
    horrible: 'Hrozné',
    very_bad: 'Velmi špatné',
    bad: 'Špatné',
    intermediate: 'Běžné',
    good: 'Dobré',
    excellent: 'Vynikající',
    grade1: 'Stupeň 1',
    grade2: 'Stupeň 2',
    grade3: 'Stupeň 3',
    grade4: 'Stupeň 4',
    grade5: 'Stupeň 5',
    no_tollway: 'Bez mýtného',
    is_tollway: 'S mýtným',
    no_category: 'Bez kategorie',
    highway: 'Dálnice',
    unpaved_road: 'Nezpevněná cesta',
    tunnel:	'Tunel',
    paved_road:	'Zpevněná cesta',
    ford: 'Brod',
    no_data: 'Nejsou data'
  }
}
